import React, { useState } from 'react';
import { toast } from 'sonner';
import { Pencil, Plus, Trash2, Users } from 'lucide-react';
import { errMsg } from '../../lib/aiInterviewApi';
import { schedulingAPI } from '../../lib/schedulingApi';
import { Empty, Loading, Pill } from '../aiinterview/recruiter/common';
import PoolDialog from './PoolDialog';

export default function PoolsTab({ pools, team, reload }) {
  const [edit, setEdit] = useState({ open: false, pool: null });
  const byId = Object.fromEntries((team || []).map((t) => [t.id, t]));
  const remove = async (p) => {
    try {
      await schedulingAPI.deletePool(p.id);
      toast.success('Pool deleted');
      reload();
    } catch (e) {
      toast.error(errMsg(e, 'Could not delete the pool'));
    }
  };
  if (!pools) return <Loading />;
  return (
    <div data-testid="pools-tab">
      <div className="iv-row" style={{ justifyContent: 'space-between', marginBottom: '0.75rem' }}>
        <p className="iv-small" style={{ margin: 0 }}>Group the people who interview for a role. Any CHIRE recruiter or admin in your company can be added.</p>
        <button type="button" className="iv-btn iv-btn-primary iv-btn-sm" onClick={() => setEdit({ open: true, pool: null })} data-testid="new-pool-btn"><Plus size={14} /> New pool</button>
      </div>
      {!pools.length ? (
        <Empty testId="pools-empty" title="No interviewer pools yet" body="Create a pool, add interviewers, and they'll share the bookings fairly." />
      ) : (
        <div style={{ display: 'grid', gap: '0.75rem', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))' }}>
          {pools.map((p) => (
            <div key={p.id} className="iv-card" style={{ marginBottom: 0 }} data-testid={`pool-card-${p.id}`}>
              <div className="iv-row" style={{ justifyContent: 'space-between' }}>
                <b style={{ color: '#002A38', fontSize: '1rem' }}><Users size={15} style={{ display: 'inline', marginRight: 6, verticalAlign: '-2px' }} />{p.name}</b>
                <span className="iv-row" style={{ gap: '0.3rem' }}>
                  <button type="button" className="iv-btn iv-btn-ghost iv-btn-sm" onClick={() => setEdit({ open: true, pool: p })} data-testid={`pool-edit-${p.id}`} aria-label="Edit pool"><Pencil size={13} /></button>
                  <button type="button" className="iv-btn iv-btn-danger iv-btn-sm" onClick={() => remove(p)} data-testid={`pool-delete-${p.id}`} aria-label="Delete pool"><Trash2 size={13} /></button>
                </span>
              </div>
              {p.description && <p className="iv-small" style={{ margin: '0.3rem 0 0' }}>{p.description}</p>}
              <div style={{ display: 'grid', gap: '0.3rem', marginTop: '0.7rem' }}>
                {p.members.map((m) => (
                  <div key={m.id} className="iv-row iv-small" style={{ justifyContent: 'space-between' }}>
                    <span>{m.name || m.email}</span>
                    <span className="iv-row" style={{ gap: '0.3rem' }}>
                      <span data-testid={`pool-${p.id}-load-${m.id}`}>{byId[m.id]?.load_30d ?? 0} in 30d</span>
                      {byId[m.id]?.calendar ? <Pill tone="green">Calendar</Pill> : <Pill tone="slate">.ics</Pill>}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
      <PoolDialog open={edit.open} pool={edit.pool} team={team} onOpenChange={(o) => setEdit((x) => ({ ...x, open: o }))} onSaved={reload} />
    </div>
  );
}
